import { createReducer, on } from '@ngrx/store';

import * as BillingSharedFeatureActions from './common.action';

export const billingSharedFeatureKey = 'billingSharedFeature';

export interface BillingSharedFeatureState {
  addPaymentMethodFailureCount: number;
}

export const initialState: BillingSharedFeatureState = {
  addPaymentMethodFailureCount: 0
};

export const billingSharedFeatureReducer = createReducer(
  initialState,
  on(
    BillingSharedFeatureActions.AddPaymentMethodFailureCount,
    (state, action): BillingSharedFeatureState => ({
      ...state,
      addPaymentMethodFailureCount: action.addPaymentMethodFailureCount
    })
  )
);
